import Swal from "sweetalert2";
import { auth } from "../../config/firebase";

const API_BASE = (
  process.env.REACT_APP_BLOOMS_API_URL || "https://ai-blooms.vercel.app/api/openai/blooms"
).replace(/\/api\/.*/, "");

/**
 * Reparte un contenido ya generado (texto Bloom o lección de inferencia) a una de
 * las secciones del maestro. Reusa el flujo del padre: el maestro genera y guarda en
 * su biblioteca como cualquier usuario; desde ahí elige a qué sección repartirlo.
 * Escribe a nivel de sección + copia en cada alumno enrolado (endpoint section-content).
 *
 * @param {object} item     El objeto guardado (texto o lección) tal cual.
 * @param {"text"|"inference"} type
 * @param {function} t      Traductor.
 */
export async function distributeToSection(item, type, t) {
  try {
    const idToken = auth.currentUser ? await auth.currentUser.getIdToken(true) : null;
    if (!idToken) return;
    const headers = { "Content-Type": "application/json", Authorization: `Bearer ${idToken}` };

    // Secciones del maestro.
    const secRes = await fetch(`${API_BASE}/api/school/sections`, { headers });
    const secData = await secRes.json();
    const sections = secData.sections || [];
    if (!sections.length) {
      Swal.fire({ icon: "info", title: t("distributeNoSectionsTitle"), text: t("distributeNoSections") });
      return;
    }

    // Selector de sección.
    const inputOptions = {};
    sections.forEach((s) => {
      inputOptions[s.id] = `${s.name}${s.grade ? " · " + s.grade : ""} — ${s.studentCount || 0} ${t("students").toLowerCase()}`;
    });
    const { value: sectionId } = await Swal.fire({
      title: t("distributeTitle"),
      text: t("distributeText"),
      input: "select",
      inputOptions,
      inputPlaceholder: t("distributeSelect"),
      showCancelButton: true,
      confirmButtonText: t("distributeConfirm"),
      cancelButtonText: t("cancel"),
      confirmButtonColor: "#eb2178",
      inputValidator: (v) => (!v ? t("distributeSelect") : undefined),
    });
    if (!sectionId) return;

    Swal.fire({ title: t("distributing"), allowOutsideClick: false, didOpen: () => Swal.showLoading() });
    const res = await fetch(`${API_BASE}/api/school/section-content`, {
      method: "POST",
      headers,
      body: JSON.stringify({ sectionId, type, payload: item }),
    });
    const out = await res.json();
    if (!res.ok) throw new Error(out.error || "Error");

    const secLabel = inputOptions[sectionId].split(" — ")[0];
    Swal.fire({
      icon: "success",
      title: t("distributeDoneTitle"),
      html: `<b>${secLabel}</b><br/>${t("distributeDoneA")} <b>${out.distributed}</b> ${t("students").toLowerCase()}.<br/><span style="color:#237a66;font-size:.9em">${t("distributeAppNote")}</span>`,
      confirmButtonColor: "#eb2178",
    });
  } catch (e) {
    Swal.fire({ icon: "error", title: t("errorTitle") || "Error", text: e.message });
  }
}
